import ContractWithUserInfoForm from "../components/form/ContractWithUserInfoForm";

const ContractInfoPage = () => {

    return (
        <ContractWithUserInfoForm 
            submitButtonChildren={"VALIDER LE FORMULAIRE"}
        />
    );
}

export default ContractInfoPage;